import React, { useCallback, useMemo } from "react";
import "./LocationSelector.scss";

import { Menu, Select, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  setCurrentFacility,
  setCurrentFacilityIds,
  setCurrentTelehalthFacility,
} from "redux/actions/calendar.actions";
import { CalenderOperationType } from "utils/enums";
import { CloseCircleOutlined, EnvironmentOutlined, SearchOutlined } from "@ant-design/icons";
import { groupBy } from "lodash";
import queryString from "query-string";
import { replace } from "connected-react-router";

const { Option } = Select;

export default function LocationSelector() {
  const {
    currentTeleFacility,
    currentFacilityIds,
    currentOperationType,
    facilities,
    isFetchingFacilities,
  } = useSelector((state) => {
    return {
      currentTeleFacility: state.calendar.currentTeleFacility,
      currentFacilityIds: state.calendar.currentFacilityIds,
      currentOperationType: state.calendar.currentOperationType,
      facilities: state.facilities.allFacilities,
      isFetchingFacilities: state.facilities.isFetchingFacilities,
    };
  });
  const dispatch = useDispatch();
  const facilityIds =
    currentOperationType === CalenderOperationType.Telehealth
      ? currentTeleFacility
      : currentFacilityIds;

  // const isTeleFacility = (facility) => {
  //   return facility?.operationTypeIds?.includes?.(3);
  // };

  // const isNormalFacility = (facility) => {
  //   return (
  //     facility?.operationTypeIds?.includes?.(1) ||
  //     facility?.operationTypeIds?.includes?.(2)
  //   );
  // };

  const filteredFacilities = useMemo(() => {
    // if (currentOperationType === CalenderOperationType.Telehealth) {
    //   return facilities.map((it) => {
    //     return {
    //       value: it.facilityId,
    //       label: it.facilityName,
    //     };
    //   });
    // } else {
    let groupedFilteredFacilities = Object.entries(
      groupBy(facilities, "state")
    ).map(([state, facilities]) => {
      return {
        label: state,
        options: facilities.map((it) => {
          return {
            value: it.facilityId,
            label: it.facilityName,
          };
        }),
      };
    });

    return groupedFilteredFacilities;
    // }
  }, [facilities, currentOperationType]);


  const setFacility = useCallback(
    (facilityIds) => {
      dispatch(setCurrentFacilityIds(facilityIds));
      let qsObj = {}
      qsObj.facilityId = facilityIds
      const searchQuery = queryString.stringify(qsObj, {
        arrayFormat: "bracket",
        ignoreQueryPrefix: true
      });
      dispatch(replace({ search: searchQuery }));

      // if clinic or mobile is selected
      // if (currentOperationType === CalenderOperationType.All) {
      //   let contitionalFacilityIds = facilityIds;
      //   // if more than one facility is selected
      //   if (facilityIds.length > 1) {
      //     let secondLastFacilityId = facilityIds[facilityIds.length - 2];
      //     let secondLastFacility = facilities.find(
      //       (facility) => facility.facilityId === secondLastFacilityId
      //     );
      //     let lastFacilityId = facilityIds[facilityIds.length - 1];
      //     let lastFacility = facilities.find(
      //       (facility) => facility.facilityId === lastFacilityId
      //     );
      //     // if a different state is selected
      //     if (secondLastFacility?.state !== lastFacility?.state) {
      //       contitionalFacilityIds = [lastFacilityId];
      //     }
      //   }

      //   dispatch(setCurrentFacilityIds(contitionalFacilityIds));
      // } else if (currentOperationType === CalenderOperationType.Telehealth) {
      //   dispatch(setCurrentTelehalthFacility(facilityIds));
      // }
    },
    [currentFacilityIds, currentOperationType, facilities]
  );

  return (
    <div className="locationSelectorContainer">
      <div className="locationSelectorIcon">
        <EnvironmentOutlined />
      </div>
      <Select
        // allowClear={true}
        className="locationSelector multiLocationSelector"
        dropdownClassName="locationSelectorDropdown"
        isSearch={true}
        placeholder="Select location center"
        optionFilterProp="children"
        value={facilityIds}
        onChange={setFacility}
        loading={isFetchingFacilities}
        filterOption={(input, option) => {
          return option.label?.toLowerCase?.().includes(input.toLowerCase());
        }}
        // optionLabelProp={"facilityName"}
        showSearch={true}
        options={filteredFacilities}
        mode="multiple"
        tagRender={(props) => {
          const { label, value, closable, onClose } = props;
          return <span>{label}</span>;
        }}
        clearIcon={<CloseCircleOutlined style={{ color: 'red', fontSize: 16 }} />}
        maxTagPlaceholder={(values) => {
          return "+" + values.length;
        }}
        maxTagCount={1}
        dropdownRender={(menu, ...x) => {
          return (
            <>
              <div style={{
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                position: 'relative',
              }}>
                <div
                  style={{ flexGrow: 1 }}
                  className="selectAllOption"
                  onClick={() => {
                    const facilityIds = facilities.map(
                      (facility) => facility.facilityId
                    );
                    setFacility(facilityIds);
                  }}
                >
                  Select All
                </div>
                {
                  currentFacilityIds?.length > 0 && <div
                    className={'locationDropdownClear'}
                    onClick={() => { setFacility([]) }}
                  >
                    Clear
                  </div>
                }

              </div>
              {menu}
            </>
          );
        }}
      />
    </div>
  );
}
